import React, { useState } from 'react';
import { Link, useLocation } from 'react-router';
import { Button } from './Button';
import useTheme from '../hooks/useTheme';

export const Header: React.FC = () => {
    const { theme, breakpoint } = useTheme();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const navLinks = [
        { path: '/', label: 'Home' },
        { path: '/about', label: 'About' },
        { path: '/services', label: 'Services' },
        { path: '/sectors', label: 'Sectors' },
        { path: '/projects', label: 'Projects' },
        { path: '/insights', label: 'Insights' },
        // { path: '/downloads', label: 'Downloads' },
        { path: '/contact', label: 'Contact' },
    ];

    const isActive = (path: string) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(path);
    };

    return (
        <>
            <header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 100,
                    background: `linear-gradient(180deg, ${theme.colors.surface} 0%, ${theme.colors.surfaceAlt} 100%)`,
                    backdropFilter: 'blur(10px)',
                    borderBottom: `1px solid ${theme.colors.border}`,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                }}
            >
                <div
                    style={{
                        background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                        height: '2px',
                        width: '100%',
                    }}
                />
                <div
                    style={{
                        maxWidth: '1120px',
                        margin: '0 auto',
                        padding: breakpoint.xs || breakpoint.sm ? '0px 16px' : '0px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '24px',
                    }}
                >
                    <Link
                        to="/"
                        style={{
                            textDecoration: 'none',
                            color: theme.text.primary,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                        }}
                    >
                        <img src="/logo.png" alt="Mega Green" style={{ height: '120px' }} />

                    </Link>

                    <nav
                        className="headerNav"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '32px',
                            flex: 1,
                            justifyContent: 'center',
                        }}
                    >
                        {navLinks.map((link) => {
                            const active = isActive(link.path);
                            return (
                                <Link
                                    key={link.path}
                                    to={link.path}
                                    style={{
                                        textDecoration: 'none',
                                        color: active ? theme.colors.primary : theme.text.muted,
                                        fontSize: '15px',
                                        fontWeight: active ? 600 : 400,
                                        transition: 'all 0.2s ease',
                                        position: 'relative',
                                        paddingBottom: '4px',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!active) {
                                            e.currentTarget.style.color = theme.colors.primary;
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!active) {
                                            e.currentTarget.style.color = theme.text.muted;
                                        }
                                    }}
                                >
                                    {link.label}
                                    {active && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                height: '2px',
                                                background: theme.gradients.button,
                                                borderRadius: '2px',
                                            }}
                                        />
                                    )}
                                </Link>
                            );
                        })}
                    </nav>

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                        }}
                        className="headerActions"
                    >
                        <Link to="/contact" style={{ textDecoration: 'none' }}>
                            <Button variant="primary" style={{ fontSize: '14px', padding: '10px 18px' }}>
                                Request a Consultation
                            </Button>
                        </Link>
                    </div>

                    <button
                        className="hamburgerBtn"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        style={{
                            display: 'none',
                            background: 'transparent',
                            border: 'none',
                            color: theme.text.primary,
                            fontSize: '24px',
                            cursor: 'pointer',
                            padding: '8px',
                        }}
                        aria-label="Toggle menu"
                    >
                        ☰
                    </button>
                </div>

                {isMenuOpen && (
                    <div
                        className="mobileMenu"
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '20px',
                            gap: '16px',
                            borderTop: `1px solid ${theme.colors.line}`,
                        }}
                    >
                        {navLinks.map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                onClick={() => setIsMenuOpen(false)}
                                style={{
                                    textDecoration: 'none',
                                    color: isActive(link.path) ? theme.colors.green.g1 : theme.text.muted,
                                    fontSize: '16px',
                                    padding: '8px 0',
                                }}
                            >
                                {link.label}
                            </Link>
                        ))}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
                            <Link to="/contact" style={{ textDecoration: 'none' }} onClick={() => setIsMenuOpen(false)}>
                                <Button variant="primary">Request a Consultation</Button>
                            </Link>
                        </div>
                    </div>
                )}
            </header>

        </>
    );
};

